import React from 'react'
import { Formik } from 'formik'
import {
  MAX_SECURITY_QUESTIONS_PER_USER,
  userSecurityQuestionsValidationSchemaFormik
} from 'shared/userSecurityQuestions'
import { defaultSecurityOptionValue } from 'front-end/src/pages/auth/security-questions/SecurityQuestionsOptions'

export type SecurityQuestionsFormValues = typeof defaultSecurityOptionValue[]

type WithSecurityQuestionsFormikProps = {
  onSubmit: (formData: SecurityQuestionsFormValues) => void
}

export const WithSecurityQuestionsFormik: React.FC<WithSecurityQuestionsFormikProps> =
  ({ children, onSubmit }) => {
    return (
      <Formik
        onSubmit={onSubmit}
        initialValues={Array(MAX_SECURITY_QUESTIONS_PER_USER).fill(
          defaultSecurityOptionValue
        )}
        enableReinitialize
        validateOnMount
        validationSchema={userSecurityQuestionsValidationSchemaFormik}
      >
        {children}
      </Formik>
    )
  }
